import { PulsingDotSvg } from "@lyteflo/components";
import { useLiveScanStore } from "@lyteflo/utils";

export const LiveScanNavIcon = ({ className = "" }: { className?: string }) => {
  const { liveScans } = useLiveScanStore();
  const hasLiveScans = liveScans.length > 0;

  return (
    <span className={className}>
      <PulsingDotSvg size={8} variant={hasLiveScans ? "pulse" : "static"} />
    </span>
  );
};
